import { useParams, Link, Navigate } from "react-router-dom";
import { Calendar, Phone, MessageCircle } from "lucide-react";
import { BLOG, COMPANY, blogUrl, waLink } from "@/data/site";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const fmt = (d) => new Date(d).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });

export default function BlogPost() {
  const { slug } = useParams();
  const cleanSlug = slug?.replace(/\.html$/, "");
  const post = BLOG.find((p) => p.slug === cleanSlug);
  if (!post) return <Navigate to="/blog.html" replace />;
  const related = BLOG.filter((p) => p.slug !== cleanSlug).slice(0, 3);

  return (
    <>
      <SEO title={`${post.title} | Blog Paulistana`} description={post.excerpt} path={`/blog/${post.slug}`} />
      <article className="bg-white">
        <div className="bg-brand-black text-white">
          <div className="max-w-3xl mx-auto container-px py-12">
            <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Blog", to: "/blog.html" }, { label: post.category }]} />
            <span className="inline-block bg-brand-red text-white text-xs font-bold uppercase px-3 py-1 rounded mt-4 mb-3">{post.category}</span>
            <h1 className="font-display font-black text-3xl sm:text-4xl leading-tight mb-3">{post.title}</h1>
            <span className="flex items-center gap-1.5 text-sm text-gray-400"><Calendar className="w-4 h-4" /> {fmt(post.date)}</span>
          </div>
        </div>

        <div className="max-w-3xl mx-auto container-px py-10">
          <img src={post.image} alt={post.title} className="rounded-xl w-full object-cover mb-8 shadow-lg" />
          <div className="prose max-w-none">
            {post.content.map((para, i) => (
              <p key={i} className="text-gray-700 leading-relaxed text-[17px] mb-5">{para}</p>
            ))}
          </div>

          <div className="bg-brand-light rounded-xl p-6 mt-8 text-center">
            <h2 className="font-display font-extrabold text-xl text-brand-black mb-2">Precisa de uma desentupidora agora?</h2>
            <p className="text-gray-600 mb-5">Atendimento 24h nos bairros nobres de São Paulo.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a href={`tel:${COMPANY.phoneTel}`} className="btn-red"><Phone className="w-5 h-5" /> {COMPANY.phoneDisplay}</a>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" className="btn-green"><MessageCircle className="w-5 h-5" /> Chamar no WhatsApp</a>
            </div>
          </div>
        </div>

        <div className="max-w-5xl mx-auto container-px pb-16">
          <h2 className="font-display font-extrabold text-2xl text-brand-black mb-6">Continue lendo</h2>
          <div className="grid sm:grid-cols-3 gap-6">
            {related.map((p) => (
              <Link key={p.slug} to={blogUrl(p.slug)} className="group block">
                <div className="h-36 rounded-lg overflow-hidden mb-3">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <h3 className="font-display font-bold text-base text-brand-black group-hover:text-brand-red transition-colors leading-snug">{p.title}</h3>
              </Link>
            ))}
          </div>
        </div>
      </article>
    </>
  );
}
